var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSupport(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#iconSupport_svg__clip0_897_7)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 1.438A7.561 7.561 0 001.437 9 7.561 7.561 0 009 16.563 7.561 7.561 0 0016.563 9 7.561 7.561 0 009 1.437zM2.546 9A6.462 6.462 0 019 2.546 6.462 6.462 0 0115.454 9 6.464 6.464 0 019 15.454 6.462 6.462 0 012.546 9zm6.58-4.117c-.794 0-1.455.186-1.92.605-.47.423-.7 1.045-.706 1.83l-.002.252h1.168l-.005-.255c-.01-.492.116-.824.332-1.035.218-.213.57-.345 1.102-.345.702 0 1.248.48 1.248 1.149 0 .438-.236.813-.603 1.156-.41.378-.69.72-.87 1.112-.179.392-.247.812-.267 1.33l-.01.259H9.76l.01-.24.003-.067c.018-.427.027-.634.104-.831.078-.202.237-.41.636-.806.552-.515.987-1.073.987-1.945 0-.673-.272-1.223-.714-1.6-.438-.374-1.03-.57-1.66-.57zm.025 6.55a.843.843 0 00-.847.84c0 .466.38.844.847.844a.843.843 0 100-1.685z",
    fill: "#879494"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "iconSupport_svg__clip0_897_7"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSupport);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "assets/iconSupport.958b01ff.svg";
export { MemoForwardRef as ReactComponent };